import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-21b93032"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "stc-legend"
};
const _hoisted_2 = {
  class: "stc-tools"
};
const _hoisted_3 = {
  class: "stc-switch"
};
const _hoisted_4 = {
  key: 0,
  class: "stc-empty"
};
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { MARKETS, renderHeat } from './heatRate';

// eslint-disable-next-line no-undef

export default {
  __name: 'SupportTrendChart',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    market: {
      type: String,
      default: 'had'
    },
    dark: {
      type: Boolean,
      default: false
    },
    fill: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '250px'
    }
  },
  setup(__props) {
    const props = __props;
    const mode = ref('amount');
    const oddsOn = ref(true); // 是否叠加赔率虚线
    const options = computed(() => MARKETS[props.market] || MARKETS.had);
    const chartEl = ref(null);
    const empty = ref(false);
    let chart = null;
    let ro = null;
    const chartStyle = computed(() => props.fill ? {
      flex: '1',
      minHeight: '0',
      width: '100%'
    } : {
      width: '100%',
      height: props.height
    });
    const draw = () => {
      const el = chartEl.value;
      if (!el) return;
      if (el.offsetHeight <= 0) return; // 折叠未展开时跳过，等 ResizeObserver
      if (!props.list || !props.list.length) {
        if (chart) {
          chart.dispose();
          chart = null;
        }
        empty.value = true;
        return;
      }
      empty.value = false;
      chart = renderHeat(el, props.list, props.market, mode.value, props.dark, oddsOn.value);
    };
    const setMode = m => {
      if (mode.value === m) return;
      mode.value = m;
      draw();
    };
    const toggleOdds = () => {
      oddsOn.value = !oddsOn.value;
      draw();
    };
    watch([() => props.list, () => props.market, () => props.dark, mode], () => draw());
    onMounted(() => {
      ro = new ResizeObserver(() => {
        const el = chartEl.value;
        if (!el) return;
        if (el.offsetHeight > 0 && !chart) {
          draw();
        } else if (chart) {
          chart.resize();
        }
      });
      if (chartEl.value) ro.observe(chartEl.value);
      draw();
    });
    onBeforeUnmount(() => {
      if (ro) ro.disconnect();
      if (chart) chart.dispose();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["stc", {
          dark: __props.dark
        }]),
        style: _normalizeStyle(__props.fill ? {
          width: '100%',
          height: '100%',
          flexDirection: 'column',
          display: 'flex'
        } : {})
      }, [_createElementVNode("div", {
        class: "stc-head",
        style: _normalizeStyle(__props.fill ? {
          flexShrink: '0'
        } : {})
      }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, o => {
        return _openBlock(), _createElementBlock("span", {
          key: o.key,
          class: "stc-lg"
        }, [_createElementVNode("i", {
          class: "stc-dot",
          style: _normalizeStyle({
            background: o.color
          })
        }, null, 4), _createTextVNode(_toDisplayString(o.label), 1)]);
      }), 128))]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
        class: _normalizeClass(["stc-sw", {
          on: mode.value === 'amount'
        }]),
        onClick: _cache[0] || (_cache[0] = $event => setMode('amount'))
      }, "金额", 2), _createElementVNode("span", {
        class: _normalizeClass(["stc-sw", {
          on: mode.value === 'pct'
        }]),
        onClick: _cache[1] || (_cache[1] = $event => setMode('pct'))
      }, "占比", 2)]), _createElementVNode("span", {
        class: _normalizeClass(["stc-sw stc-odds", {
          on: oddsOn.value
        }]),
        onClick: toggleOdds
      }, "赔率", 2)])], 4), _createElementVNode("div", {
        ref_key: "chartEl",
        ref: chartEl,
        class: "stc-chart",
        style: _normalizeStyle(chartStyle.value)
      }, null, 4), empty.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, "暂无数据")) : _createCommentVNode("", true)], 6);
    };
  }
};